import cx from 'classnames'

import MermaidIcon from 'assets/icons/logos/mermaid24.svg'
import {
  Airtable,
  Canva,
  Clickup,
  EmbedIntegrations,
  EmbedURL,
  Figma,
  Github,
  GoogleDocs,
  GoogleForms,
  GoogleMaps,
  GoogleSheets,
  GoogleSlides,
  Integration,
  Jira,
  Loom,
  Mermaid,
  Miro,
  Twitter,
  Vimeo,
  Youtube,
} from 'proseShared/IntegrationsIcons'
import Styles from '../Prompt.module.scss'
import { ReactComponent as LinkIcon } from '../icons/link.svg'

export interface Props {
  activeIntegration: Integration
  setActiveIntegration: (integration: Integration) => void
}

const Sidebar = ({ activeIntegration, setActiveIntegration }: Props) => {
  const renderIcon = (integration: Integration) => {
    switch (integration) {
      case EmbedURL:
        return <LinkIcon />
      case Loom:
        return (
          <img
            src="https://res.cloudinary.com/almanac/image/upload/f_auto,q_auto/v1611084704/public/icons/Loom_ef6mfa.png"
            alt="Loom icon"
          />
        )
      case Airtable:
        return (
          <img
            src="https://res.cloudinary.com/almanac/image/upload/f_auto,q_auto/v1611084704/public/icons/Airtable_rqwe0d.png"
            alt="Airtable icon"
          />
        )
      case Figma:
        return (
          <img
            src="https://res.cloudinary.com/almanac/image/upload/f_auto,q_auto/v1611084704/public/icons/Figma_qu9czj.png"
            alt="Figma icon"
          />
        )
      case Github:
        return (
          <img
            src="https://res.cloudinary.com/almanac/image/upload/f_auto,q_auto/v1611084704/public/icons/Github_ymiltu.png"
            alt="Github icon"
          />
        )
      case GoogleMaps:
        return (
          <img
            src="https://res.cloudinary.com/almanac/image/upload/f_auto,q_auto/v1611084704/public/icons/Google_Maps_cnnor4.png"
            alt="GoogleMaps icon"
          />
        )
      case Jira:
        return (
          <img
            src="https://res.cloudinary.com/almanac/image/upload/f_auto,q_auto/v1651612784/public/icons/Jira_icon_qwmjff.png"
            alt="Jira icon"
          />
        )
      case Miro:
        return (
          <img
            src="https://res.cloudinary.com/almanac/image/upload/f_auto,q_auto/v1611084704/public/icons/Miro_lkk40y.png"
            alt="Miro icon"
          />
        )
      case Twitter:
        return (
          <img
            src="https://res.cloudinary.com/almanac/image/upload/f_auto,q_auto/v1611084704/public/icons/Twitter_asyky3.png"
            alt="Twitter icon"
          />
        )
      case Youtube:
        return (
          <img
            src="https://res.cloudinary.com/almanac/image/upload/f_auto,q_auto/v1611084704/public/icons/Youtube_t3mhk2.png"
            alt="Youtube icon"
          />
        )
      case Vimeo:
        return (
          <img
            src="https://res.cloudinary.com/almanac/image/upload/f_auto,q_auto/v1619780017/public/icons/Vimeo_icon_1_txwnxb.png"
            alt="Vimeo icon"
          />
        )
      case GoogleDocs:
        return (
          <img
            src="https://res.cloudinary.com/almanac/image/upload/f_auto,q_auto/v1619780240/public/icons/Google_Docs_Icon_wrmgni.png"
            alt="GoogleDocs icon"
          />
        )
      case GoogleForms:
        return (
          <img
            src="https://res.cloudinary.com/almanac/image/upload/f_auto,q_auto/v1619780240/public/icons/Google_Forms_Icon_zpcwio.png"
            alt="GoogleForms icon"
          />
        )
      case GoogleSheets:
        return (
          <img
            src="https://res.cloudinary.com/almanac/image/upload/f_auto,q_auto/v1619780241/public/icons/Google_Sheets_Icon_aikcit.png"
            alt="GoogleSheets icon"
          />
        )
      case GoogleSlides:
        return (
          <img
            src="https://res.cloudinary.com/almanac/image/upload/f_auto,q_auto/v1619780240/public/icons/Google_Slides_Icon_kmttrb.png"
            alt="GoogleSlides icon"
          />
        )
      case Canva:
        return (
          <img
            className={Styles.iconSize}
            src="https://res.cloudinary.com/almanac/image/upload/f_auto,q_auto/v1647993259/public/icons/Canva_icon_rzfvd9.png"
            alt="Canva icon"
          />
        )
      case Clickup:
        return (
          <img
            className={Styles.iconSize}
            height="20px"
            src="https://res.cloudinary.com/almanac/image/upload/f_auto,q_auto/v1647993487/public/icons/Clickup_icon_l0rjm4.png"
            alt="Clickup icon"
          />
        )
      case Mermaid:
        return <img className={Styles.iconSize} height="20px" src={MermaidIcon} alt="Mermaid Icon" />
      default:
        break
    }
  }

  const renderIntegration = (integration: Integration) => {
    return (
      <li
        key={integration.name}
        className={cx({
          [Styles.activeAction]: integration === activeIntegration,
          [Styles.disabledAction]: !integration.enabled,
          [Styles.defaultCursor]: EmbedIntegrations.includes(integration),
        })}
      >
        <button
          aria-label={integration.name}
          disabled={!integration.enabled}
          onClick={() => setActiveIntegration(integration)}
        >
          {renderIcon(integration)}
          {integration.name}
          {!integration.enabled && <span>(Coming soon)</span>}
        </button>
      </li>
    )
  }

  return (
    <div className={Styles.mediaUploadSidebar}>
      <p>Embed</p>
      <ul>{renderIntegration(EmbedURL)}</ul>

      <ul>{EmbedIntegrations.map((integration) => renderIntegration(integration))}</ul>
    </div>
  )
}

export default Sidebar
